/**
 * Pharmacy queue illustration as a decorative background (behind cards / content).
 */

function QueueSvg({ h, w }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="xMidYMid slice"
      style={{ display: "block" }}
      focusable="false"
    >
      <defs>
        <linearGradient id="ed-queue-floor-bg" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f0f9ff" />
          <stop offset="100%" stopColor="#e2e8f0" />
        </linearGradient>
      </defs>
      <rect width={w} height={h} fill="url(#ed-queue-floor-bg)" />
      <rect x="0" y="0" width={w} height={h * 0.42} fill="#f8fafc" opacity="0.95" />
      <g fill="#cbd5e1" opacity="0.55">
        {[32, 98, 164, 230, 296, 362, 428].map((x) => (
          <rect key={x} x={x} y="18" width="44" height="28" rx="4" />
        ))}
      </g>
      <g fill="#94a3b8" opacity="0.35">
        {[40, 106, 172, 238, 304, 370, 436].map((x) => (
          <rect key={x} x={x} y="52" width="36" height="22" rx="3" />
        ))}
      </g>
      <path
        d={`M ${w * 0.52} ${h * 0.38} H ${w} V ${h} H 0 V ${h * 0.72} L ${w * 0.52} ${h * 0.38} Z`}
        fill="#0c4a6e"
        opacity="0.92"
      />
      <rect x={w * 0.52} y={h * 0.32} width={w * 0.48} height={h * 0.09} rx="6" fill="#0ea5e9" opacity="0.14" />
      <rect x={w * 0.56} y={h * 0.34} width={w * 0.22} height={h * 0.05} rx="4" fill="#f8fafc" opacity="0.9" />
      <ellipse cx={w * 0.78} cy={h * 0.28} rx="14" ry="16" fill="#64748b" />
      <rect x={w * 0.76} y={h * 0.32} width="24" height="38" rx="8" fill="#475569" />
      {[
        { x: 0.12, s: 1 },
        { x: 0.2, s: 0.98 },
        { x: 0.28, s: 0.96 },
        { x: 0.36, s: 0.94 },
        { x: 0.44, s: 0.92 },
        { x: 0.51, s: 0.9 },
        { x: 0.58, s: 0.88 },
        { x: 0.65, s: 0.86 },
      ].map((p, i) => {
        const cx = w * p.x;
        const scale = p.s;
        const headR = 11 * scale;
        const bodyW = 22 * scale;
        const bodyH = 44 * scale;
        const baseY = h * 0.88;
        return (
          <g key={i} opacity={0.55 + i * 0.055}>
            <ellipse cx={cx} cy={baseY - bodyH - headR * 0.4} rx={headR} ry={headR * 1.05} fill="#334155" />
            <rect
              x={cx - bodyW / 2}
              y={baseY - bodyH}
              width={bodyW}
              height={bodyH}
              rx={bodyW * 0.35}
              fill={i % 3 === 0 ? "#0369a1" : i % 3 === 1 ? "#0d9488" : "#4f46e5"}
              opacity="0.85"
            />
          </g>
        );
      })}
      <line x1="0" y1={h * 0.88} x2={w} y2={h * 0.88} stroke="#94a3b8" strokeWidth="1" opacity="0.25" />
    </svg>
  );
}

/**
 * Full-viewport decorative layer. SVG scales with cover (slice) so it always fills the frame.
 *
 * @param {"absolute" | "fixed"} position — `fixed` above upload backdrop (z-index 1); `absolute` on sign-up shell.
 */
export function PharmacyQueueBackground({ position = "absolute" }) {
  const h = 220;
  const w = 560;
  const zIndex = position === "fixed" ? 1 : 0;

  return (
    <div
      aria-hidden
      className="ed-pharmacy-queue-background"
      style={{
        position,
        inset: 0,
        zIndex,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: position === "fixed" ? 0.36 : 0.44,
        }}
      >
        <QueueSvg h={h} w={w} />
      </div>
    </div>
  );
}
